import { render, staticRenderFns } from "./BaseRadio.vue?vue&type=template&id=3962e8ad"
import script from "./BaseRadio.vue?vue&type=script&lang=js"
export * from "./BaseRadio.vue?vue&type=script&lang=js"
import style0 from "./BaseRadio.vue?vue&type=style&index=0&id=3962e8ad&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports